import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.tsx";
import "./index.css";
import { initMouseTracking } from "./lib/anti-fraud";
import { isNativeMobile, setupPushNotifications, configureStatusBar } from "./lib/mobile-capabilities";

const queryClient = new QueryClient();

// Initialize anti-fraud tracking
initMouseTracking();

// Initialize native mobile features
if (isNativeMobile()) {
  setupPushNotifications();
  configureStatusBar();
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
